/**
 * 融合渠道流水强切
 */
import { createAPI } from '../setup'
import hostConfig from '../config'
const CASHIER = {
    // 获取支付方式列表
    listPayWay: (data) => createAPI(`${hostConfig.apiHost}/web/pay/listPayWay`, 'post', data),
    // 获取支付令牌
    createSwitchOrder: (data) => createAPI(`${hostConfig.apiHost}/web/pay/createSwitchOrder`, 'post', data),
    // 检查订单支付
    checkOrderStatus: (data) => createAPI(`${hostConfig.apiHost}/web/pay/checkOrderStatus`, 'post', data)
}
export default CASHIER
